import { Component } from '@angular/core';
import { SplitByCapitalLetterPipePipe } from "@shared/pipes/split-by-capital-letter-pipe.pipe";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { SigningStatus } from "@models/annual-statements/annual-statement-enums";

@Component({
  selector: 'app-ag-annual-signing-status',
  standalone: true,
  imports: [
    SplitByCapitalLetterPipePipe,
  ],
  templateUrl: './ag-annual-signing-status.component.html',
  styleUrl: './ag-annual-signing-status.component.scss'
})
export class AgAnnualSigningStatusComponent implements ICellRendererAngularComp{
  protected status: SigningStatus | null | undefined;
  protected readonly SigningStatus = SigningStatus;

  agInit(params: ICellRendererParams<SigningStatus, SigningStatus>): void {
    this.status = params.value;
  }

  refresh(params: ICellRendererParams<SigningStatus, SigningStatus>): boolean {
    this.status = params.value;
    return true;
  }
}
